import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { routerMiddleware } from 'connected-react-router'
import { createStore, applyMiddleware, compose as _compose } from 'redux'

import createRootReducer from '../reducers'

const compose =
  typeof window !== 'undefined' &&
  window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']
    ? window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']({
        actionsBlacklist: ['@@'],
      })
    : _compose

const configureStore = (history, preloadedState = {}) => {
  const reduxRouterMiddleware = routerMiddleware(history)
  const rootReducer = createRootReducer(history)

  const debugMiddleware = process.env.debug
    ? [createLogger({ collapsed: true })]
    : []
  const middleware = [thunk, reduxRouterMiddleware, ...debugMiddleware]

  const store = createStore(
    rootReducer,
    preloadedState,
    compose(applyMiddleware(...middleware))
  )

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      store.replaceReducer(rootReducer)
    })
  }

  return store
}

export default configureStore
